<template>
  <div>
    <el-row class="sign-up-form">
      <el-col :span="22">
        <div>
          <div class="sign-up-form-input">
            <el-form
              :label-position="lablePosition"
              label-width="13rem"
              ref="ruleForm"
              :rules="rules"
              :model="form">
              <el-form-item label="用户名：" prop="userName">
                <el-input placeholder="请输入用户名" v-model="form.userName" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="昵称：" prop="nickName">
                <el-input placeholder="请输入昵称" v-model="form.nickName"></el-input>
              </el-form-item>
              <el-form-item label="手机号：" prop="phonenumber">
                <el-input placeholder="请输入手机号" v-model="form.phonenumber" :disabled="loginMethod == 'phone'"></el-input>
              </el-form-item>
              <transition name="el-zoom-in-top">
                <el-form-item label="短信验证码：" prop="phoneActivation" v-if="changePhone">
                  <el-row>
                    <el-col :span="16">
                      <el-input
                        v-model="form.phoneActivation"
                        auto-complete="autoComplete"
                        placeholder="请输入短信验证码"
                        style="width:100%"
                      ></el-input>
                    </el-col>
                    <el-col :span="8">
                      <div class="login-code">
                        <el-button
                          :disabled="phoneCaptchaDisabled"
                          @click="phoneCaptcha"
                          style="padding: 0 !important;height:40px;line-height: 40px;">
                          <span>{{phoneButtonName}}</span>
                        </el-button>
                      </div>
                    </el-col>
                  </el-row>
                </el-form-item>
              </transition>
              <el-form-item label="电子邮箱：" prop="email">
                <el-input placeholder="请输入邮箱地址" v-model="form.email" :disabled="loginMethod == 'email'"></el-input>
              </el-form-item>
              <transition name="el-zoom-in-top">
                <el-form-item label="邮箱验证码：" prop="emailActivation" v-if="changeEmail">
                  <el-row>
                    <el-col :span="16">
                      <el-input
                        v-model="form.emailActivation"
                        auto-complete="autoComplete"
                        placeholder="请输入邮箱验证码"
                        style="width:100%"
                      ></el-input>
                    </el-col>
                    <el-col :span="8">
                      <div class="login-code">
                        <el-button
                          :disabled="emailCaptchaDisabled"
                          @click="emailCaptcha"
                          style="padding: 0 !important;height:40px;line-height: 40px;"
                        >
                          <span>{{emailButtonName}}</span>
                        </el-button>
                      </div>
                    </el-col>
                  </el-row>
                </el-form-item>
              </transition>
              <el-form-item label="设置/修改密码：" prop="nickName">
                <div
                  v-if="form.password === undefined || form.password === null || form.password === ''"
                >
                  <span class="changePwd" @click="setPwd">设置密码</span>
                </div>
                <div v-else>
                  <span class="changePwd" @click="changePwd">修改密码</span>
                 <!--  <span @click="changePwd">&nbsp|&nbsp</span> -->
                  <!-- <span class="changePwd" @click="resetPwd">忘记密码</span> -->
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="sign-up-form bottom">
      <div class="buttonDiv">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-button
              type="success"
              @click="saveContParticipant"
              style="background-color:#39C1C2"
              :disabled="disabledBtn"
            >保存</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
    <changePwd :resetPwdVisible="changePwdVisible"></changePwd>
    <setPwd :childForm="childForm" :resetPwdVisible="setPwdVisible" @setPassword="setPasswordParent" ></setPwd>
    <!-- <resetPwdForm :resetPwdVisible="resetPwdVisible"></resetPwdForm> -->
  </div>
</template>

<script>
import ChildLogo from '../../../components/ChildLogo'
import commitment from '../../../components/commitment'
import loginForm from '../../../components/login'
import changePwd from './changePwd'
import setPwd from './setPwd'
import {getToken} from '../../../utils/auth'
//  import resetPwdForm from "../../../components/resetPwd"

export default {
  name: 'SignUp',
  components: {
    ChildLogo,
    commitment,
    loginForm,
    changePwd,
    setPwd
  },
  data () {
    var email = (rule, value, callback) => {
      if (!value) {
        //  return callback(new Error("邮箱不能为空"))
        callback()
      }
      let user = this.$store.state.user
      let mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
      if (mailReg.test(value)) {
        if (user.email !== value) {
          var api = this.systemURL + '/actuator/before/verifyEmail'
          var params = { email: value }
          this.axios.post(api, params).then(res => {
            if (res.data.sysUser === 'existEmail') {
              return callback(new Error('该邮箱已注册'))
            } else {
              this.changeEmail = true
              callback()
            }
          })
        } else {
          this.changeEmail = false
          callback()
        }
      } else {
        callback(new Error('请输入正确的邮箱格式'))
      }
    }
    var phone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      }
      let user = this.$store.state.user
      let mailReg = /^1[3456789]\d{9}$/
      if (mailReg.test(value)) {
        if (user.phonenumber !== value) {
          var api = this.systemURL + '/actuator/before/verifyPhone'
          var params = { phonenumber: value }
          this.axios.post(api, params).then(res => {
            if (res.data.sysUser === 'existPhone') {
              return callback(new Error('该手机号已注册'))
            } else {
              this.changePhone = true
              callback()
            }
          })
        } else {
          this.changePhone = false
          callback()
        }
      } else {
        callback(new Error('请输入正确的手机号'))
      }
    }
    return {
      form: {
        userId: '',
        userName: '',
        nickName: '',
        phonenumber: '',
        email: '',
        password: '',
        emailActivation: '',
        phoneActivation: '',
        phoneUuid: '',
        emailUuid: ''
      },
      //  worksDeclareDisabled: true,
      worksDeclareId: null,
      lablePosition: 'right',
      disabledBtn: false,
      changePhone: false,
      changeEmail: false,
      time: 60,
      phoneCaptchaDisabled: false,
      emailCaptchaDisabled: false,
      phoneButtonName: '发送短信',
      emailButtonName: '发送邮件',
      resetPwdVisible: false,
      changePwdVisible: false,
      setPwdVisible: false,
      // 向子组件传递用户数据
      childForm: [],
      rules: {
        email: [{ validator: email, trigger: 'blur' }],
        phonenumber: [{ required: true, validator: phone, trigger: 'blur' }],
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        emailActivation: [
          { required: true, message: '请输入邮箱验证码', trigger: 'blur' }
        ],
        phoneActivation: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' }
        ]
      },
      loginMethod: ''
    }
  },
  beforeMount () {
    //  添加判断方法
    let mobile = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )

    if (mobile) {
      this.lablePosition = 'top'
    }
  },
  mounted () {
    this.loginMethod = window.sessionStorage.getItem('loginMethod')
    if (this.$store.state.user) {
      for (let key in this.form) {
        this.form[key] = this.$store.state.user[key]
      }
    } else {
      this.$message({
        message: '请先登录',
        type: 'warning'
      })
    }
  },
  watch: {
    '$store.state.user': function (newFlag, oldFlag) {
      //  location.reload()
    }
  },
  methods: {
    phoneCaptcha () {
      // 发送手机验证码
      let account = this.form.phonenumber
      let mailReg = /^1[3456789]\d{9}$/
      if (!mailReg.test(account)) {
        this.$message.warning('请确认手机号是否正确')
        return
      }
      var api = this.systemURL + '/actuator/before/getPhoneCaptcha'
      var params = {
        account: account,
        siteId: this.siteId
      }
      this.phoneCaptchaDisabled = true
      this.axios.post(api, params).then(res => {
        if (res.data.code === 500) {
          this.$message.error(res.data.msg)
          this.phoneCaptchaDisabled = false
          return
        }
        this.form.phoneUuid = res.data.uuid
        this.$message.success(res.data.msg)
        let interval = window.setInterval(() => {
          this.phoneButtonName = '(' + this.time + '秒)后重发'
          --this.time
          if (this.time < 0) {
            this.phoneButtonName = '重新发送'
            this.time = 30
            this.phoneCaptchaDisabled = false
            window.clearInterval(interval)
          }
        }, 1000)
      })
    },
    emailCaptcha () {
      // 发送手机验证码
      let account = this.form.email
      let mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
      if (!mailReg.test(account)) {
        this.$message.warning('请确认邮箱是否正确')
        return
      }
      var api = this.systemURL + '/actuator/before/getEmailCaptcha'
      var params = {
        account: account
      }
      this.emailCaptchaDisabled = true
      this.axios.post(api, params).then(res => {
        if (res.data.code === 500) {
          this.$message.error(res.data.msg)
          this.emailCaptchaDisabled = false
          return
        }
        this.form.emailUuid = res.data.uuid
        this.$message.success(res.data.msg)
        let interval = window.setInterval(() => {
          this.emailButtonName = '(' + this.time + '秒)后重发'
          --this.time
          if (this.time < 0) {
            this.emailButtonName = '重新发送'
            this.time = 30
            this.emailCaptchaDisabled = false
            window.clearInterval(interval)
          }
        }, 1000)
      })
    },
    saveContParticipant () {
      this.$refs['ruleForm'].validate(valid => {
        /* if (this.form.email != "" || this.form.email != null) {
          let user = this.$store.state.user
          let mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
          if (mailReg.test(value)) {
            if (user.email != value) {
              var api = this.systemURL + "/actuator/before/verifyEmail"
              var params = { email: value }
              this.axios.post(api, params).then(res => {
                if (res.data.sysUser == "existEmail") {
                  return "该邮箱已注册"
                } else {
                  this.changeEmail = true
                  return null
                }
              })
            } else {
              this.changeEmail = false
              return null
            }
          } else {
            return "请输入正确的邮箱格式"
          }
        } */
        if (valid) {
          this.disabledBtn = true
          var api = this.systemURL + '/actuator/before/editUserN'
          this.form.token = getToken()
          this.axios
            .post(api, this.form)
            .then(res => {
              if (res.data.code === 200) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                //  console.log(res.data.data)
                this.$store.commit('setUser', res.data.data)
              } else {
                this.$message(res.data.msg)
              }
              this.disabledBtn = false
            })
            .catch(() => {
              this.disabledBtn = false
              this.$message({
                message: '保存失败',
                type: 'error'
              })
            })
        } else {
          this.$message({
            message: '验证信息是否正确',
            type: 'error'
          })
        }
      })
    },
    changePwd () {
      this.changePwdVisible = true
    },
    /*   resetPwd() {
      this.resetPwdVisible = true
    }, */
    setPwd () {
      this.setPwdVisible = true
      this.childForm = this.form
    },
    setPasswordParent (password) {
      this.form.password = password
    }
  }
}
</script>

<style scoped>
/* 通知公告基础模块 */
.sign-up {
  min-height: 80px
}
/* 通知公告竖线样式 */
.sign-up-line {
  float: left;
  width: 5px;
  height: 50px;
  background-image: linear-gradient(#133c73, #37babd);
  margin-top: 20px;
}
.sign-up-text {
  margin-left: 10px;
  float: left;
  height: 40px;
  margin-top: 20px;
}
.sign-up-text-cn {
  font-size: 24px;
}
.sign-up-text-en {
  font-size: 15px;
  color: #999;
}
/* 表单基础样式 */
.sign-up-form {
  margin-top: 10px;
  height: 100%;
  /* padding-left: 50px; */
  padding: 30px 0;
}
.sign-up-form-input {
  /* margin-top: 10px; */
  margin: 0 auto;
  width: 100%;
}
/* elementui   表单控件长度修改 */
.el-select {
  width: 100%;
}
.el-input {
  width: 100%;
}
.bottom {
  margin-top: 0;
  text-align: center;
  color: #409eff;
  line-height: 19px;
  font-size: 14px;
  padding: 0rem 5rem;
}
.buttonDiv {
  margin: 50px;
  padding: 0 25%;
}
.changePwd {
  font-size: 14px;
  color: #37babd;
  cursor: pointer;
}
</style>
<style>
.el-form-item__label {
  font-size: 16px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/my/components/myInfo.vue